function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 2.41233,
  y: 2.48533,
  width: 50.9815,
  height: 52.5418,
  rx: 25.4908,
  stroke: "white",
  strokeWidth: 3.45797
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M40.1885 23.137C40.376 22.5492 40.1885 22.1222 39.3613 22.1222H36.6118C35.917 22.1222 35.5971 22.4972 35.4096 22.8975C35.4096 22.8975 33.9947 26.315 32.0188 28.5304C31.3791 29.1717 31.0845 29.3844 30.7378 29.3844C30.5503 29.3844 30.3108 29.1717 30.3108 28.584V23.1102C30.3108 22.4169 30.0965 22.0955 29.5088 22.0955H25.1837C24.7567 22.0955 24.4904 22.4169 24.4904 22.7367C24.4904 23.4048 25.4783 23.564 25.5839 25.4343V29.4916C25.5839 30.3723 25.4248 30.5331 25.0765 30.5331C24.1422 30.5331 21.8733 27.0887 20.5119 23.1637C20.244 22.3901 19.9778 22.0955 19.2829 22.0955H16.5066C15.7062 22.0955 15.5723 22.4705 15.5723 22.8707C15.5723 23.5907 16.5066 27.2226 19.9242 32.0283C22.1931 35.312 25.4248 37.0751 28.335 37.0751C30.0965 37.0751 30.3108 36.6734 30.3108 36.0069V33.5236C30.3108 32.7232 30.47 32.5893 31.0309 32.5893C31.4311 32.5893 32.1528 32.802 33.782 34.3776C35.6507 36.2464 35.9705 37.1019 37.012 37.1019H39.7615C40.5635 37.1019 40.937 36.7001 40.7227 35.9265C40.4832 35.1529 39.5756 34.031 38.4002 32.6964C37.7589 31.948 36.7977 31.1208 36.5047 30.7206C36.1045 30.1864 36.2116 29.9721 36.5047 29.4916C36.4779 29.4916 39.8419 24.7394 40.1885 23.137Z",
  fill: "white"
});

var SvgIcVk = function SvgIcVk(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcVk, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-vk.d75dbb09.svg";
export { ForwardRef as ReactComponent };